import Constants from "./Constants";

const STORAGE_KEY = 'erma-auth';


/**
 * Store the Auth object to local storage
 * @param {string} jwt 
 */
export const storeAuth = (jwt) => {
  let auth = {
    jwt: jwt
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
}

/**
 * Removes the Auth object from the local storage
 */
export const clearAuth = () => {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Get the Auth object from the local storage
 */
export const getAuth = () => {
  var auth = null;
  var authString = localStorage.getItem(STORAGE_KEY);

  if (authString !== null) {
    auth = JSON.parse( authString );
  }

  return auth;
}

/**
 * Checks to see if the user is authenticated, if they are returns TRUE, otherwise FALSE
 */
export const isUserAuthenticated = () => {
  var auth = getAuth();
  
  //TODO: Probally needs some more strength around it, but the calls to APIs will fail if token is invalid!
  let isAuthorised = auth !== "" && auth !== undefined && auth !== null && auth?.jwt !== undefined && auth?.jwt !== null;
  
  // If the user is not authorised we need to bug out early.
  if (!isAuthorised) {
    return false;
  }

  let isTokenExpired = isJwtExpired(auth.jwt);
  
  if (isTokenExpired) { // May need to add role checks here as well at some point.
    isAuthorised = false;
  }

  return isAuthorised;
}

/**
 * Checks to see if the user has the specified role, if they do returns TRUE, otherwise FALSE
 * @param {string|string[]} role - One, or an array of, Constants.UserRole
 * @returns boolean
 */
export const hasUserRole = (role) => {
  let jwt = getAuth()?.jwt;

  if (jwt === undefined || jwt === null) {
    return false;
  }

  let needles = [];
  let roles = getJwtBodyField( jwt, "roles");

  // Check if the provided role value is a array or roles or just a single role
  if ( !Array.isArray(role) ) {
    needles.push(role);
  } else {
    needles = role;
  }

  let foundRoles = [];

  needles.forEach((needle) => {
    if (roles?.includes(needle)) {
      foundRoles.push(needle);
    }
  });

  return foundRoles.length > 0;
}

/**
 * 
 * @returns Returns the current users member Id
 */
export const getMemberId = () => {
  let memberId = getJwtBodyField(getAuth().jwt, "sub");

  return memberId;
}

/**
 * Returns true if the expire time in the JWT has past
 */
const isJwtExpired = (jwt) => {
  let expiresAt = getJwtBodyField(jwt, "exp");
  let timeNow = Math.floor(Date. now() / 1000);

  return expiresAt < timeNow;
}

/**
 * Extracts fields from the JWT
 */
const getJwtBodyField = (jwt, fieldName) => {
  let jwtBody = jwt.split(".")[1];
  jwtBody = JSON.parse( atob(jwtBody) );
  return jwtBody[fieldName];
}